import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';

import placeholder from 'lib/placeholder';

import CategoriesDropdown from '../../CategoriesDropdown';
import StoresDropdown from '../../StoresDropdown';
import FeaturedLandings from './FeaturedLandings';
import NavItem from './NavItem';
import SponsoredAds from './SponsoredAds';

import LINKS from 'constants/links';

const MAIN_NAVS_LIST = [
  {
    url: LINKS.BLOG,
    bgUrl: null,
    text: placeholder('actions.seeBlog'),
    gaEventAction: 'topbar_blog_tab',
    icon: <Icon name="article" />,
  },
  {
    url: LINKS.COUPONS,
    bgUrl: null,
    text: placeholder('actions.seeCoupons'),
    gaEventAction: 'topbar_coupon_tab',
    icon: <Icon name="discount-filled" />,
  },
  {
    url: LINKS.FORUM,
    bgUrl: null,
    text: placeholder('actions.seeForum'),
    gaEventAction: 'topbar_forum_tab',
    icon: <Icon name="messages" />,
  },
  {
    url: LINKS.ALIEXPRESS_BIG_DEALS,
    bgUrl: LINKS.ALIEXPRESS_FIRST_PURCHASE_DEALS,
    text: placeholder('actions.seeAliexpressSponsored'),
    gaEventAction: 'aliexpress_sponsor_tab',
    icon: <Icon name="aliexpress" />,
  },
];

const DefaultNavigation = ({ gaEventCategory }) => (
  <>
    <CategoriesDropdown gaEventCategory={gaEventCategory} />
    <StoresDropdown gaEventCategory={gaEventCategory} />
    {MAIN_NAVS_LIST.map(({ bgUrl, gaEventAction, icon, text, url }) => (
      <NavItem
        key={url}
        bgUrl={bgUrl}
        gaEventAction={gaEventAction}
        gaEventCategory={gaEventCategory}
        icon={icon}
        text={text}
        unreadStatus={url === LINKS.ALIEXPRESS_BIG_DEALS}
        url={url}
      />
    ))}
    <SponsoredAds gaEventCategory={gaEventCategory} />
    <FeaturedLandings gaEventCategory={gaEventCategory} />
  </>
);

DefaultNavigation.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default DefaultNavigation;
